import { Head, useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { adminProductions } from '@/routes'

export default function NewProduction() {
  const form = useForm({ production: { title: '', notes: '' } })

  return (
    <Card className="max-w-xl">
      <Head title="New production" />
      <CardHeader>
        <CardTitle>New production</CardTitle>
      </CardHeader>
      <CardContent>
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault()
            form.submit(adminProductions.create())
          }}
        >
          <div className="grid gap-2">
            <Label htmlFor="title">Title</Label>
            <Input
              id="title"
              value={form.data.production.title}
              onChange={(e) => form.setData('production.title', e.target.value)}
              required
            />
            {form.errors['production.title'] && (
              <p className="text-sm text-destructive">{form.errors['production.title']}</p>
            )}
          </div>
          <div className="grid gap-2">
            <Label htmlFor="notes">Notes</Label>
            <Textarea
              id="notes"
              value={form.data.production.notes}
              onChange={(e) => form.setData('production.notes', e.target.value)}
              placeholder="Dates, venue, anything the cast should know"
            />
          </div>
          <Button type="submit" disabled={form.processing} className="justify-self-start">
            Create production
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
